/**
 * Map configuration constants for MeCell Maps
 *
 * These values define the coordinate system and tile settings for the cell map.
 */

import type { MapConfig } from '../types';

/**
 * Map extent in pixels [minX, minY, maxX, maxY]
 * Origin is at top-left (0, 0), Y increases downward (negative)
 */
export const MAP_EXTENT: [number, number, number, number] = [0, -21252, 30000, 0];

/**
 * Resolutions for each zoom level (0-7)
 * Resolution = map units per pixel at that zoom
 * Lower resolution = more zoomed in
 */
export const RESOLUTIONS: number[] = [
  117.1875, 58.59375, 29.296875, 14.6484375, 7.32421875, 3.662109375, 1.8310546875,
  0.91552734375,
];

/**
 * Tile size in pixels
 */
export const TILE_SIZE: number = 256;

/**
 * URL template for tile images
 */
export const TILE_URL: string = '/maptiles/{z}/{x}/{y}.png';

/**
 * Initial view center (approximately center of the cell)
 */
export const INITIAL_CENTER: [number, number] = [15000, -10626];

/**
 * Initial resolution (zoom level 2-3)
 */
export const INITIAL_RESOLUTION: number = RESOLUTIONS[2]; // 29.296875

/**
 * Minimum resolution (most zoomed in - zoom level 7)
 */
export const MIN_RESOLUTION: number = RESOLUTIONS[7]; // 0.91552734375

/**
 * Maximum resolution (most zoomed out - zoom level 0)
 */
export const MAX_RESOLUTION: number = RESOLUTIONS[0]; // 117.1875

/**
 * Animation duration in milliseconds for smooth transitions
 */
export const ANIMATION_DURATION: number = 500;

/**
 * All configuration bundled together
 */
export const MAP_CONFIG: MapConfig = {
  extent: MAP_EXTENT,
  resolutions: RESOLUTIONS,
  tileSize: TILE_SIZE,
  tileUrl: TILE_URL,
  initialCenter: INITIAL_CENTER,
  initialResolution: INITIAL_RESOLUTION,
  minResolution: MIN_RESOLUTION,
  maxResolution: MAX_RESOLUTION,
  animationDuration: ANIMATION_DURATION,
};
